export const DO_NOT_HAVE_FREE_TRIAL = "não possui"

export function productsMapperSelect(products: App.Product[]) {
  return products.map((product: App.Product) => ({
    label: product.prefixUrl,
    value: product.prefixUrl
  }))
}

export function accountMapperSelect(accounts: App.Account[]) {
  return accounts.map((account: App.Account) => ({
    label: `${account.name} (${account.id})`,
    value: account.id
  }))
}

export function purchasePlanMapperSelect(purchasePlans: App.PurchasePlan[]) {
  return purchasePlans.map((purchasePlan: App.PurchasePlan) => ({
    label: `${purchasePlan.name} (${purchasePlan.planKey} - ${purchasePlan._id})`,
    value: purchasePlan._id
  }))
}

function formatFreeTrial(hasFreeTrial: boolean, freeTrialDuration: App.FreeTrialDuration): string {
  const { unit, amount } = freeTrialDuration

  if (hasFreeTrial && unit === "Month") {
    return `${amount} ${amount > 1 ? "meses" : "mês"}`
  } else if (hasFreeTrial && unit === "Day") {
    return `${amount} dia${amount > 1 ? "s" : ""}`
  } else {
    return DO_NOT_HAVE_FREE_TRIAL
  }
}

function formatBillingType(billingType: string) {
  if (billingType === "subscription") {
    return "por mês"
  }
  if (billingType === "rate") {
    return "por uso"
  }

  return ""
}

function formatPrice(price: number, currency: string) {
  const fractionalDigits = (price.toString().split(".")[1] || "").length
  const minimumFractionDigits = fractionalDigits > 2 ? fractionalDigits : 2

  return price.toLocaleString("pt-BR", {
    style: "currency",
    currency,
    minimumFractionDigits
  })
}

export function eventTypesMapper(eventTypes: App.EventTypeResponse[]) {
  return eventTypes
    .map((eventType: App.EventTypeResponse) => {
      return {
        id: eventType.id,
        key: eventType.key,
        name: eventType.name,
        price: formatPrice(eventType.price, eventType.currencyType),
        billing: formatBillingType(eventType.billingType),
        freeTrial: formatFreeTrial(eventType.hasFreeTrial, eventType.freeTrialDuration),
        product: eventType.product,
        account: eventType.account,
        isSimplePricing: eventType.isSimplePricing,
        purchasePlan: eventType.purchasePlan,
        currencyType: eventType.currencyType,
        hasFreeTrial: eventType.hasFreeTrial,
        freeTrialDuration: {
          amount: eventType.freeTrialDuration.amount,
          unit: eventType.freeTrialDuration.unit,
          usageLimit: eventType.freeTrialDuration.usageLimit
        },
        isPublished: eventType.isPublished ?? true
      }
    })
    .sort((a, b) => a.key.localeCompare(b.key, "pt-br", { numeric: true }))
}
